<template>
  <div>
    <template>
      <div>
        <mu-tabs v-if="routetype == 0" style="background-color:#fff;" :value="activeTab1" @change="handleTabChange1">
          <mu-tab value="all1" style="color:#000;" title="一级脑能力" disabled />
          <mu-tab v-if="index < 6" :value="index" titleClass="tab-font" v-for="item,index in evalList" @click="changeList(item)" :title="item.scaleTagName">
          </mu-tab>
        </mu-tabs>
        <mu-tabs v-if="routetype == 0" style="background-color:#fff;" :value="activeTab1" @change="handleTabChange1">
          <mu-tab v-if="index > 5" :value="index" titleClass="tab-font" v-for="item,index in evalList" @click="changeList(item)" :title="item.scaleTagName">
          </mu-tab>
        </mu-tabs>
        <mu-tabs v-else-if="routetype != 0" style="background-color:#fff;" :value="activeTab2" @change="handleTabChange2">
          <mu-tab value="all2" style="color:#000;" title="一级脑能力" disabled />
          <mu-tab :value="index" titleClass="tab-font" v-for="item,index in evalList" v-if = "item.scaleGroupId==routetype" @click="changeList(item)" :title="item.scaleTagName"/>
        </mu-tabs>

        <!-- <div v-if="routetype == 0">
          <mu-breadcrumb style="font-size:14px;margin-left:30px;margin-top:10px;" separator="|">
            <mu-breadcrumb-item href="">一级脑能力：</mu-breadcrumb-item>
            <mu-breadcrumb-item href="javascript:void(0);" v-for="item in evalList" style="display:inline-block;margin-top:5px;">
              <span @click="changeList(item,$event)"  class="second-t">{{item.scaleTagName}}</span></mu-breadcrumb-item>
            <mu-breadcrumb-item href="">&nbsp;</mu-breadcrumb-item>
          </mu-breadcrumb>
        </div>

        <div v-else-if="routetype != 0">
          <mu-breadcrumb style="font-size:14px;margin-left:30px;margin-top:10px;" separator="|">
            <mu-breadcrumb-item href="">一级脑能力：</mu-breadcrumb-item>
            <mu-breadcrumb-item href="javascript:void(0);" v-for="item in evalList" v-if = "item.scaleGroupId == routetype" style="display:inline-block;margin-top:5px;">
              <span @click="changeList(item,$event)"  class="second-t">{{item.scaleTagName}}</span></mu-breadcrumb-item>
            <mu-breadcrumb-item href="">&nbsp;</mu-breadcrumb-item>
          </mu-breadcrumb>
        </div> -->

      </div>
    </template>
    <div id="evalContent">

      <!--2.0量表开始-->
      <template v-for="item in evllist">
        <div v-show="showList">
          <div class="evalItem" v-if="routetype == 0">
              <div class="board pointer" @click="showDetail(item.scaleName,item.id,item.scaleAlias,caseId='')">
              <img :src="'/static/images/assess_icons/' + item.scaleName + '/icon.svg'"/>
              </div>
            <div class="boardName">{{ item.scaleName }}</div>
          </div>

          <div class="evalItem" v-else-if="routetype != 0">
            <div v-if="item.scaleGroupId==routetype">
              <div class="board pointer" @click="showDetail(item.scaleName,item.id,item.scaleAlias,caseId='')">
                <img :src="'/static/images/assess_icons/' + item.scaleName + '/icon.svg'"/>
              </div>
              <div class="boardName">{{ item.scaleName }}</div>
            </div>
          </div>
        </div>
        <div v-show="hideList">
          <div class="evalItem">
            <div v-if="item.scaleTagId == judge">
              <div class="board pointer" @click="showDetail(item.scaleName,item.id,item.scaleAlias,caseId='')">
                <img :src="'/static/images/assess_icons/' + item.scaleName + '/icon.svg'"/>
              </div>
              <div class="boardName">{{ item.scaleName }}</div>
            </div>
          </div>
        </div>
    </template>
    <!--2.0量表结束-->

      <!--1.0量表开始-->
    <div v-show="showList">
      <template v-for="item in eval1">
        <div class="evalItem" v-if="routetype == 0 && item.RESULTEXPLAIN != null">
          <div class="board pointer" @click="showDetail1(item.SCALENAME,item.ID,item.RESULTEXPLAIN,caseId='')">
            <img :src="'/static/images/assess_icons/' + item.SCALENAME + '/icon.svg'"/>
          </div>
          <div class="boardName">{{ item.SCALENAME }}</div>
        </div>
        <div class="evalItem" v-else-if="routetype != 0 && item.RESULTEXPLAIN!=null">
          <div v-if="item.scaleGroupId == routetype">
            <div class="board pointer" @click="showDetail1(item.SCALENAME,item.ID,item.RESULTEXPLAIN,caseId='')">
            <img :src="'/static/images/assess_icons/' + item.SCALENAME + '/icon.svg'"/>
            </div>
            <div class="boardName">{{ item.SCALENAME }}</div>
          </div>
        </div>
      </template>
    </div>
    <div v-show="hideList">
      <template v-for="item in eval1">
        <div class="evalItem" v-if="item.RESULTEXPLAIN != null">
          <div v-if="item.scaleTagId == judge || (item.scaleTagId == 27 && judge == 19)">
            <div class="board pointer" @click="showDetail1(item.SCALENAME,item.ID,item.RESULTEXPLAIN,caseId='')">
            <img :src="'/static/images/assess_icons/' + item.SCALENAME + '/icon.svg'"/>
            </div>
            <div class="boardName">{{ item.SCALENAME }}</div>
          </div>
        </div>
      </template>
    </div>
      <!--1.0量表结束-->

  <div id="container">
    <evalContentmodal :showDialog="showModal"></evalContentmodal>
  </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import evalContentmodal from './evalContentmodal.vue'
var _ = require('lodash');
// import evalPage from '../evaluation/recordPage.vue'

  export default ({
    data() {
      return {
        store: require('../../../app/store.js'),
        activeTab1: "",
        activeTab2: "",
        evalList: [],
        judge:" ",
        num:" ",
        WAB:{
          scaleTagId:21,
          scaleTagName:"言语综合测验",
          scaleGroupId:5,
        },//wab量表
        searchNum:'',
        searchCon:'',
        routetype:this.$route.params.id,
        evllist:[],
        caseId: '', //病例id
        caseIdDoc:'',//临时测评
        scaleId: '',//量表id
        scaleAlias: '', //量表
        scaleAliasName: '', //量表别名
        startType:'',//判断是1.0或者2.0测评
        //test
        showModal: false,
        sexB: '男',
        sexClick: true,
        name: '',
        age: '',
        pages:1,
//        1.0量表
        eval1:[],
        scalehave:true,
        flag:0,
        lsuser:''
      }
    },
    components: {
      evalContentmodal
    },
    computed:{
      showList () {
        return this.$store.state.evalItems.show;
      },
      hideList () {
        return this.$store.state.evalItems.hide;
      }
    },
    methods: {
      repairMuseui2($event){
        $('a span').removeClass('active-second-t');
        if($event){
          $($event.target).addClass('active-second-t');
        }
      },
      changeList (item,$event) {
        this.repairMuseui2($event);
        this.judge = item.scaleTagId;
        this.num = item.scaleTagId;
        this.$store.commit("changeEval");
      },
      handleTabChange1 (val) {
        this.activeTab1 = val;
      },
      handleTabChange2 (val) {
        this.activeTab2 = val;
      },
      clearEvalList () {
        this.$store.commit("clearEval");
      },
      childCallTwo:function(childparam){//接受evalution.vue父页面传来的参数
        this.routetype=childparam;
        this.activeTab1 = -1;
      },
      fetch:function(type){
        var self = this;
        Vue.http({
            method: 'GET',
            url:'/api/Evaluation/getScales',
            params: {}
          })
          .then(
            function(res){
              for(var key in res.data.data){
                var kk = res.data.data[key];
                self.evllist.push(kk);
              }
            }
          );
        //     1.0接口开始
        Vue.http({
          method : 'GET',
          url : '/api/Evaluation/assess_scales',
        }).then(function(res){
            var log = console.log.bind(console);
            self.eval1 = res.data.data;
            var count = res.data.data;
            var listArrTI = [],
                listArrTN = [],
                listArrGI = [];
            var listGI = [];
            for (var i = 0; i < count.length; i++) {
              if (typeof count[i].scaleTagName != "undefined") {
                for (var j = 0; j < Object.keys(count[i]).length; j++) {
                  if (listArrTN.indexOf(count[i].scaleTagName) == -1) {
                    listArrTN.push(count[i].scaleTagName);
                  }
                  if (listArrTI.indexOf(count[i].scaleTagId) == -1) {
                    listArrTI.push(count[i].scaleTagId);
                    listArrGI.push(count[i].scaleGroupId);
                  }
                }
              }
            }
            for (var i = 0; i < listArrTI.length; i++) {
              var list = {};
              list["scaleTagId"] = listArrTI[i];
              list["scaleTagName"] = listArrTN[i]
              list["scaleGroupId"] = listArrGI[i]
              self.evalList.push(list);
            }
            self.evalList.push(self.WAB);
          //硬性生成排序
          let newEvalList = [];
          self.evalList.forEach(function(item) {
            switch(item.scaleTagId){
              case 13:
                newEvalList[0] = item;
                break;
              case 15:
                newEvalList[1] = item;
                break;
              case 19:
                newEvalList[2] = item;
                break;
              case 21:
                newEvalList[3] = item;
                break;
              case 27:
                newEvalList[4] = item;
                break;
              case 28:
                newEvalList[5] = item;
                break;
              case 29:
                newEvalList[6] = item;
                break;
              case 32:
                newEvalList[7] = item;
                break;
              case 73:
                newEvalList[8] = item;
                break;
              case 74:
                newEvalList[9] = item;
                break;
              case 75:
                newEvalList[10] = item;
                break;
            }
          });
          self.evalList = newEvalList;
          //end硬性生成排序
        });
          //   1.0接口结束
      },
      showDetail:function(scaleName,scaleId,scaleAlias,caseId){
        this.showModal=true;
        this.caseId= caseId;
        this.startType=2;
        this.scaleName = scaleName;
        this.scaleId = scaleId;
        this.scaleAlias = scaleAlias;
      },
      showDetail1:function (scaleName,scaleId,scaleAlias,caseId) {
        this.showModal=true;
        this.caseId = caseId;
        this.startType=1;
        this.scaleName = scaleName;
        this.scaleId = scaleId;
        this.scaleAlias = scaleAlias;
      },
    },
    mounted(){
      this.fetch(0);
    },
    beforeDestroy: function () {
      this.inited = false;
    }
  })

  function  getLsUserCaseId(){
    var globalCaseIdDoc = ''
    var search ={
      keyword: '临时测评虚拟患者'
    }

    Vue.http({
      method: 'GET',
      url:'/api/Cases/getList',
      params: {
        'search':  search,
      }
    }).then(
        function (res){
          globalCaseIdDoc = res.data.data[0].id;
        }
    );
    return globalCaseIdDoc;
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  @import "../../../assets/css/app.styl";
  @import "../../../assets/css/variable.styl";

  .evalMenu
    border-bottom 1px solid #eee
    tap-highlight-color transparent
    -webkit-tap-highlight-color transparent
    -moz-tap-highlight-color transparent
    span
      display inline-block
      width 112px
      height 60px
      line-height 60px
      text-align center
      cursor pointer
    :hover
        color $color-font-primary
    :active
      color $color-font-primary
    .u-first
      width 86px
      padding-left 35px
    .u-second
      padding-left 30px
      text-align center
      width auto
      opacity .5
      tap-highlight-color transparent
      -webkit-tap-highlight-color transparent
      -moz-tap-highlight-color transparent
  .on1
    color #444
  .on1.u-second
    opacity 1
  /*以下是本页面自定义样式*/
  .evalItem
    display block
    margin-top 0
    margin-left 30px
  :empty
    margin-left 0
  .boardName
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  div.evalItem:nth-child(4n+1) div.board
    background-color #658456!important
  div.evalItem:nth-child(4n+2) div.board
    background-color #374D6C!important
  div.evalItem:nth-child(4n+3) div.board
    background-color #C44646!important
  div.evalItem:nth-child(4n+0) div.board
    background-color #90633C!important
</style>



// WEBPACK FOOTER //
// evalContent.vue?20b926c8